import { gql } from '@apollo/client';

export const BUYER_ADD_USER_MUTATION = gql`
  mutation UsersPageBuyerAddUser(
    $buyerId: ID!
    $userId: ID!
    $input: BuyerUserInput
  ) {
    buyerAddUser(buyerId: $buyerId, userId: $userId, input: $input) {
      buyer {
        id
      }
      user {
        id
      }
    }
  }
`;
